import { render } from "./errorPage1.vue?vue&type=template&id=561f89e8"
import script from "./errorPage1.vue?vue&type=script&lang=js"
export * from "./errorPage1.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__